const authentication = '/authentication/v1'

const dashboardBase = authentication + '/dashboard'
const dashboard = {
	TENANT: dashboardBase + '/tenant',
}

const operatorBase = authentication + '/operator'
const operator = {
	BASE: operatorBase,
	LOGIN: operatorBase + '/login',
	LOGOUT: operatorBase + '/logout',
	SIGNUP: operatorBase + '/signUp',
	LIST: operatorBase + '/list',
	ACCESS: operatorBase + '/access',
	PERMISSION: operatorBase + '/permission',
	CHANGE_PASSWORD: operatorBase + '/changePassword',
}

const validateOnlinePayment = authentication + '/gmp-billing/core'

export default {
	BASE: authentication,
	MASTER_CONFIG: authentication + '/company/companyAttribute',
	DASHBOARD: dashboard,
	OPERATOR: operator,
	VALIDATE_ONLINE_PAYMENT: validateOnlinePayment + '/validateOnlinePayment',
	BILLING_PAYMENT: validateOnlinePayment + '/makeBillingPayment',
	ADDCARD_REDIRECTION_URL: authentication + '/consumer/payment/redirectUrl',
	ADDCARD_URL: authentication + '/consumer/payment',
	PRORATION_API: '/authentication/v2/permit/prorated-cost/',
	PARKING_API: authentication + '/parking',
	VALIDATE_PASSWORD: authentication + '/operator/validatePassword',
}
